export default "__VITE_ASSET__a9488e28__"